import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SliderMenuService {

  public showSliderMenu() {
    const sliderMenu = document.querySelector('#digi-slider-menu');
    if (sliderMenu && sliderMenu.classList.contains('hide')) {
      sliderMenu.classList.remove('hide');
    }
  }

  public hiddenSliderMenu() {
    const sliderMenu = document.querySelector('#digi-slider-menu');
    if (sliderMenu && !sliderMenu.classList.contains('hide')) {
      sliderMenu.classList.add('hide');
    }
  }
}
